import { CursorGrid } from "../../shared/services"

import type { Point } from "../../shared/types"
import type { ResolvedResampling } from "../types/Resampling"

// Each target pixel takes the source pixel under its centre: the same picks the server's PngToCur
// makes, which a canvas's nearest-neighbour doesn't promise.
const sampleNearest = ({ data, width }: ImageData, size: number) => {
  const picks = Array.from({ length: size }, (_, i) =>
    Math.floor(((2 * i + 1) * width) / (2 * size)),
  )
  const sampled = new ImageData(size, size)
  picks.forEach((sourceY, y) => {
    picks.forEach((sourceX, x) => {
      const from = (sourceY * width + sourceX) * 4
      sampled.data.set(data.subarray(from, from + 4), (y * size + x) * 4)
    })
  })
  return sampled
}

// The frame at a cursor size, scaled the way the downloaded file's entry of that size is. Drawn here
// because a browser scales a cursor image its own way, and image-rendering doesn't reach cursors.
export const cursorImageUrl = (pixels: ImageData, size: number, resampling: ResolvedResampling) => {
  const canvas = document.createElement("canvas")
  canvas.width = size
  canvas.height = size
  const context = canvas.getContext("2d")
  if (!context) return canvas.toDataURL("image/png")

  if (resampling === "crisp") {
    context.putImageData(sampleNearest(pixels, size), 0, 0)
  } else {
    const master = document.createElement("canvas")
    master.width = pixels.width
    master.height = pixels.height
    master.getContext("2d")?.putImageData(pixels, 0, 0)
    context.imageSmoothingQuality = "high"
    context.drawImage(master, 0, 0, size, size)
  }
  return canvas.toDataURL("image/png")
}

// The extension pins `body a`/`body button`/body cursors with !important; an id rule matches the
// importance and outguns them on specificity. The hotspot uses the server's integer math
// (PngToCur), so the zone feels exactly like the downloaded file at this size.
export const cursorRule = (zoneId: string, url: string, hotspot: Point, size: number) => {
  const x = Math.floor((hotspot.x * size) / CursorGrid.SIZE)
  const y = Math.floor((hotspot.y * size) / CursorGrid.SIZE)
  return `#${zoneId}, #${zoneId} * { cursor: url("${url}") ${x} ${y}, auto !important; }`
}
